import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SelectWithData from './SelectWithData'
import tenantActions from '../../store/tenant/actions'

//actions

export const SelectTenant = (props) => {
  const dispatch = useDispatch()

  const { editable = true } = props

  const [nextPage, setNextPage] = useState(1)
  const tenantsListRoot = useSelector((state) =>
    _.get(state, `tenants.tenants`, { data: [] })
  )

  // we will just always reload tenants - not exp check
  useEffect(() => {
    if (nextPage !== false) {
      loadPage(nextPage)
    }
  }, [nextPage])

  const loadPage = (page = 1) => {
    if (!editable) {
      return
    }
    dispatch(tenantActions.listTenants({ page: page })).then((response) => {
      if (response.meta.current_page < response.meta.last_page) {
        setNextPage(response.meta.current_page + 1)
      } else {
        setNextPage(false)
      }
    })
  }

  const fetchNextPage = () => {
    if (nextPage) {
      loadPage(nextPage)
    }
  }

  const data = tenantsListRoot.data?.map((t) => {
    t.label = t.display_name + ' (' + t.id + ')'
    return t
  })

  return (
    <SelectWithData
      {...props}
      dataRows={data}
      linkStyle={true}
      value={'' + props.defaultValue}
      labelField={'label'}
      onChangeText={(value, userInitiated) => {
        props.onChangeText(value?.id ?? null, userInitiated)
      }}
      onEndReached={() => {
        fetchNextPage()
      }}
    />
  )
}
